import { GET_NLEARN3_ACADEMIC_YEARS, GET_NLEARN3_BATCHES, GET_NLEARN3_BRANCHES, GET_NLEARN3_CLASSES, GET_NLEARN3_SECTIONS, GET_NLEARN3_STREAMS } from "utils/graphql/services/live-classes/queries";
import * as Yup from "yup";

export const table = {
    primaryData: [
        {
            title: "ID",
            value: "id",
            type: "configue",
        },
        {
            title: "Package Name",
            value: "name",
            type: "configue",
        },
        {
            title: "Academic Year",
            value: "academicYearName",
            type: "configue",
        },
        {
            title: "College Name",
            value: "collegeName",
            type: "configue",
        },
        {
            title:"Class Name",
            value: "className",
            type: "configue",
        },
        {
            title: "Stream Name",
            value: "streamName",
            type: "configue",
        },
        {
            title: "Batch Name",
            value: "batchName",
            type: "configue",
        },
        {
            title: "Section Name",
            value: "sectionName",
            type: "configue",
        },
    ],
    secondaryData: [
            {
            title: "Created At",
            value: "createdAt",
            type: "configue",
        },
        {
            title: "Updated At",
            value: "updatedAt",
            type: "configue",
            name: "updatedAt"
        },
        {
            title: "Created By",
            value: "createdByName",
            type: "configue",
        },
        {
            title: "Updated By",
            value: "updatedByName",
            type: "configue",
            name: "updatedByName"
        },
    ],
};

export type Nl3LiveclassPackage = {
    batchId: string;
    classId: string;
    collegeId: string;
    sectionId: string;
    academicYearId: string;
    streamId: string;
};

export const nl3LiveclassPackageInitialValues: Nl3LiveclassPackage = {

    batchId: "",
    classId: "",
    collegeId: "",
    sectionId: "",
    academicYearId: "",
    streamId: "",
};

export const nl3LiveclassPackageMandatoryFields = [
    { id: "batchId" },
    { id: "classId" },
    { id: "collegeId" },
    { id: "sectionId" },
    { id: "academicYearId" },
    { id: "streamId" },
];

export const nl3LiveclassPackageValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
});

export const nl3LiveclassPackageProperties = [

    {
        id:"academicYearId",
        type:"single-select-search",
        label:"Academic Year *",
        keyValue: { label: "name", value: "objectId" },
        query: GET_NLEARN3_ACADEMIC_YEARS,
        gqlKey: "getNlearn3AcademicYears",
        dataKey: "nlearn3AcademicYears",
        extraPayload: { isArchived: false },
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
      },
      {
        id: "collegeId",
        type: "single-select-search",
        label: "College *",
        keyValue: { label: "name", value: "objectId" },
        query: GET_NLEARN3_BRANCHES,
        gqlKey: "getNlearn3Branches",
        dataKey: "nlearn3Branches",
        extraPayload: { isArchived: false },
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
      },
       {
        id: "classId",
        type: "single-select-search",
        label: "Class *",
        keyValue: { label: "name", value: "objectId" },
        query: GET_NLEARN3_CLASSES,
        gqlKey: "getNlearn3Classes",
        dataKey: "nlearn3Classes",
        extraPayload: { isArchived: false },
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
      }, 
      {
        id: "streamId",
        type: "single-select-search",
        label: "Stream *",
        keyValue: { label: "name", value: "objectId" },
        query: GET_NLEARN3_STREAMS,
        gqlKey: "getNlearn3Streams",
        dataKey: "nlearn3Streams",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
      },
      {
        id: "batchId",
        type: "single-select-search",
        label: "Batch *",
        keyValue: { label: "name", value: "objectId" },
        query: GET_NLEARN3_BATCHES,
        gqlKey: "getNlearn3Batches",
        dataKey: "nlearn3Batches",
        extraPayload: { isArchived: false },
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
      },
      {
        id:"sectionId",
        type:"single-select-search",
        label:"Section *",
        keyValue: { label: "name", value: "objectId" },
        query: GET_NLEARN3_SECTIONS,
        gqlKey: "getNlearn3Sections",
        dataKey: "nlearn3Sections",
        searchFieldKey: "searchName",
        breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: true,
      }
    ];

export function hasAtLeastOneValue(obj: any, keys: any[]) {
    return keys.some((key) => {
        const value = obj[key];
        return (
            value !== "" &&
            value !== null &&
            value !== undefined &&
            !(Array.isArray(value) && value.length === 0) &&
            !(Array.isArray(value) && value.every(v => v === null))
        );
    });
}

